import { render, staticRenderFns } from "./Sitemap.page.vue?vue&type=template&id=408fa06d&"
import script from "./Sitemap.page.vue?vue&type=script&lang=js&"
export * from "./Sitemap.page.vue?vue&type=script&lang=js&"
import style0 from "./Sitemap.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports